import styled from 'styled-components';
import { PageContentMixin } from '../../mixins/components/PageContentMixin';
import { doNotForwardTransientProp } from '../../util/doNotForwardTransientProp';
export var StyledPageContent = /*#__PURE__*/styled('div').withConfig({
  shouldForwardProp: doNotForwardTransientProp(['display'])
}).withConfig({
  displayName: "StyledPageContent",
  componentId: "c11n-8-111-1__sc-opuuk8-0"
})(["", ""], PageContentMixin);